import { Api } from '../AApi'

export const API_RASTER_SOURCE = new Api({ url: 'raster-sources' })
